import request from "@/util/request.js";

// POST​/shiyizhihui_platform_api​/business​/businessList
// 查询列表
export const businessList = (data) => {
  return request({
    url: "/business/businessList",
    method: "post",
    data,
  });
};

// GET​/shiyizhihui_platform_api​/business​/businessStatus
// 状态启用/禁用
export const businessStatus = (params) => {
  return request({
    url: "/business/businessStatus",
    method: "get",
    params,
  });
};

//   GET​/shiyizhihui_platform_api​/business​/businessDelete
// 删除
export const businessDelete = (params) => {
  return request({
    url: "/business/businessDelete",
    method: "get",
    params,
  });
};

//   POST​/shiyizhihui_platform_api​/business​/saveOrUpdateBusiness
// 新增或者修改
export const saveOrUpdateBusiness = (data) => {
  return request({
    url: "/business/saveOrUpdateBusiness",
    method: "post",
    data,
  });
};

//   GET​/shiyizhihui_platform_api​/business​/businessDetail
// 查询详情
export const businessDetail = (params) => {
  return request({
    url: "/business/businessDetail",
    method: "get",
    params,
  });
};
